module.exports = __webpack_public_path__ + "static/img/IOS1.1d29a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IOS1.png
// module id = qpcL
// module chunks = 1